// TODO: re-export snackbar from skooldio qms ui
import { Snackbar, SnackbarProps } from '@mui/material';

import snackbarTheme from './Snackbar';

export default Snackbar;
export { snackbarTheme };
export type { SnackbarProps };
